import React, { useEffect, useState } from "react";
import useScript from "../../Pages/Form/useScript";
import { SignService } from "../../Services";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons/faWarning";
import { toast } from "react-toastify";
import { Row } from "react-bootstrap";

const SzafirComponent = ({
  type,
  taskList,
  setIsAppletActive,
  contractNumber,
  successReturnUrl,
  failureReturnUrl,
}) => {
  const [useApplet, setIsUseApplet] = useState(false);
  const [szafirResult, setSzafirResult] = useState();
  const navigate = useNavigate();
  const isJQueryLoaded = useScript(
    "/node_modules/jquery/dist/jquery.min.js",
    "jQuery"
  );
  const isScriptLoaded = useScript(
    isJQueryLoaded ? "/Szafir/WebModule/szafirsdk-module.js" : null,
    "SZAFIR_SDK"
  );

  function printlnMessage(message, success, progress) {
    if (success) {
      $("#MessageContainerProgress").width(progress);
      $("#MessageContainer").html(
        '<div class="alert alert-success">' + message + "</div>"
      );
    } else {
      $("#MessageContainerProgress").width("100%");
      $("#MessageContainer").html(
        '<div class="alert alert-warning">' + message + "</div>"
      );
    }
  }

  function submitForm() {
    let pageString = '';
    
    pageString = contractNumber === 2 ? 'ContractFormv2' : (type === 1 ? 'ContractForm' : 'ApplicationForm');

    const data = {
      ResultFromApplet: szafirResult,
      SuccessURL: `/m1/${pageString}?result=1`,
      FailureURL: `/m1/${pageString}?result=0`,
      type: type,
    };

    SignService.signResult(data)
      .then((response) => {
        if (!!response.data.signResult) {
          navigate(`/${pageString}?result=1`);
          window.location.reload();
        } else {
          if (response.data.signFailInfo) {
            toast.error(response.data.signFailInfo);
            setIsAppletActive(false);
          }
        }
      })
      .catch((error) => {
        toast.error(`Umowa nie została podpisana. Spróbuj ponownie!`);
        setIsAppletActive(false);
        console.error(error);
      });
  }

  useEffect(() => {
    if (szafirResult !== null && szafirResult?.length > 0) {
      submitForm();
    }
  }, [szafirResult]);

  // Rozwiązanie dla Mozilli i IE

  var fnSzafirAppletResultHandler = onAppletInitResultHandler; // Pierwsza funkcja, później jest nadpisana.
  var fnSzafirAppletErrorHandler = onError;
  var _szafirAppletMultipartBuffer = "";

  // Handlery do obsługi wyniku funkcji appletu
  function onAppletInitResultHandler(result) {
    printlnMessage("Applet został zainicjowany!", true, "25%");
    window.CA.setWindowDimension(600, 800);
    // 0 – podgląd wyłączony; 1 – podgląd włączony, sformatowany (wartość domyślna); 2 – podgląd włączony, binarny.
    window.CA.setPreviewMode(0);
    window.setTimeout(startComponent(), 1000);
  }

  function onStartComponentResultHandler(result) {
    //Ustawianie certyfikatu do pobrania znacznika czasu...
    printlnMessage("Komponenty SDK zostały załadowane!", true, "75%");
    window.setTimeout(doTaskList(), 1000);
  }

  function onDoTaskListResultHandler(result) {
    printlnMessage("Otrzymano wynik.<br>Przekierowywanie...", true, "100%");
    setSzafirResult(result);
  }

  // Handlery do obsługi błędów
  function onError(error) {
    printlnMessage(
      "Błąd wywołania funkcji appletu SzafirSDK:\n\n" + error,
      false
    );
  }

  // Funkcje modyfikujące bieżące handlery wyniku i błędów
  function setSzafirAppletResultHandler(fn) {
    fnSzafirAppletResultHandler = fn;
  }
  function setSzafirAppletErrorHandler(fn) {
    fnSzafirAppletErrorHandler = fn;
  }

  // Funkcja wywoływana przez applet kumulująca wynik do lokalnej zmiennej
  function appendAsyncSzafirAppletResultPart(resultPart) {
    _szafirAppletMultipartBuffer += resultPart || "";
  }
  // Funkcja wywoływana przez applet zwracająca wynik do bieżącego handlera
  function setAsyncSzafirAppletResult(result) {
    if (fnSzafirAppletResultHandler instanceof Function) {
      if (
        (result || "").length === 0 &&
        _szafirAppletMultipartBuffer.length > 0
      ) {
        result = _szafirAppletMultipartBuffer;
      }
      _szafirAppletMultipartBuffer = "";

      fnSzafirAppletResultHandler(result);
    } else {
      alert("ERROR: fnSzafirAppletResultHandler not set");
    }
    fnSzafirAppletResultHandler = undefined;
  }
  // Funkcja wywoływana przez applet zwracająca błąd do bieżącego handlera
  function setAsyncSzafirAppletError(error) {
    if (fnSzafirAppletErrorHandler instanceof Function) {
      fnSzafirAppletErrorHandler(error);
    } else {
      alert("ERROR: fnSzafirAppletErrorHandler not set");
    }
  }

  // Funkcja startująca komponent oraz ustawiajaca handler jezeli sie zakonczy poprawnie
  function startComponent() {
    printlnMessage("Uruchamianie komponentu...", true, "50%");
    setSzafirAppletResultHandler(onStartComponentResultHandler);
    window.CA.startComponentURI("/Szafir/settings_cryptoproviders_q.xml");
  }

  function doTaskList() {
    setSzafirAppletResultHandler(onDoTaskListResultHandler);
    printlnMessage("Przetwarzanie zadania...", true, "90%");
    window.CA.doTaskListNoWindow(atob($("#ToDoTaskList").val()), true);
    printlnMessage("Oczekiwanie na wynik...", true, "100%");
  }

  function checkToUseApplet() {
    var useAppletHelper = false;
    var isFireFox52 = false;

    var userAgent = navigator.userAgent.toLowerCase();
    var browserVersion;

    function getBrowserVersion() {
      var match = userAgent.match(/(firefox|chrome|opera|edge)\/?\s*(\d+)/i);
      if (match && match.length > 2) {
        return parseInt(match[2], 10);
      }
      return 0;
    }

    if (userAgent.indexOf("firefox") > -1) {
      browserVersion = getBrowserVersion();
      if (browserVersion >= 52) {
        isFireFox52 = true;
      }
    }

    if (
      userAgent.indexOf("opera") === -1 &&
      userAgent.indexOf("chrome") === -1 &&
      userAgent.indexOf("edge") === -1 &&
      !isFireFox52
    ) {
      useAppletHelper = true;
    }

    setIsUseApplet(useAppletHelper);
  }

  useEffect(() => {
    checkToUseApplet();
  }, []);

  useEffect(() => {
    if (!isScriptLoaded) {
      return;
    }

    window.setTimeout(function () {
      // TimeOut daje czas na załadowanie rozszerzenia
      if (window.SZAFIR_SDK.isModeExtension()) {
        // Rozwiązanie dla Chrome i Opera
        if (window.SZAFIR_SDK.isExtInitialized()) {
          // Wczytano rozszerzenie - obsługa
          window.SZAFIR_SDK.config({
            sdk_location_url: "/Szafir/ext/",
            versions_file: "/Szafir/ext/versions.xml",
            onErrorNoExtension: function (error) {
              printlnMessage(
                "Błąd ładowania appletu SZAFIR_SDK: onErrorNoExtension() " +
                  error,
                false
              );
            },
            onErrorNoHostApp: function (error) {
              printlnMessage(
                'Brak zainstalowanej aplikacji <a class="alert-link" href="https://www.elektronicznypodpis.pl/aplikacje-i-sterowniki">Szafir Host</a>. Po zainstalowaniu aplikacji wymagany jest restart przeglądarki',
                false
              );
            },
            onError: function (error) {
              printlnMessage(
                "Błąd ładowania appletu SZAFIR_SDK: " + error,
                false
              );
            },
            debug: false,
          });
          printlnMessage("Applet został zainicjowany!", true, "25%");

          window.setTimeout(function () {
            printlnMessage("Uruchamianie biblioteki Szafir...", true, "50%");

            window.SZAFIR_SDK.loadSzafir(
              function () {
                printlnMessage("Uruchamianie komponentu...", true, "75%");

                window.SZAFIR_SDK.startComponentURI(
                  "/Szafir/settings_cryptoproviders_q.xml",
                  function () {
                    printlnMessage(
                      "Komponenty SDK zostały załadowane. Oczekiwanie na wynik...",
                      true,
                      "100%"
                    );

                    window.SZAFIR_SDK.doTaskList(
                      atob($("#ToDoTaskList").val()),
                      function (result) {
                        printlnMessage(
                          "Otrzymano wynik.<br>Przekierowywanie...",
                          true,
                          "100%"
                        );
                        setSzafirResult(() => result);
                      },
                      function (mess) {
                        printlnMessage(
                          "Zadanie zakończyło się niepowodzeniem: " + mess,
                          false
                        );
                      }
                    );
                  },
                  function (mess) {
                    printlnMessage(
                      "Błąd ładowania komponentu SZAFIR_SDK: " + mess,
                      false
                    );
                  }
                );
              },
              function (mess) {
                printlnMessage(
                  "Błąd ładowania appletu SZAFIR_SDK: " + mess,
                  false
                );
              }
            );
          }, 1500);
        } else {
          printlnMessage(
            'Przeglądarka wymaga zainstalowanego rozszerzenia <a class="alert-link" href=\'' +
              window.SZAFIR_SDK.getExtLink() +
              '\'>Podpis elektroniczny Szafir SDK</a> oraz aplikacji <a class="alert-link" href="https://www.elektronicznypodpis.pl/aplikacje-i-sterowniki">Szafir Host</a>.' +
              " Po instalacji należy uruchomić ponownie przeglądarkę.",
            false,
            "100%"
          );
        }
      }
    }, 1000);
  }, [isScriptLoaded]);

  return (
    <>
      <body class="szafirComponent" data-szafirsdk-ready="yes">
        <div className="warning-info-container">
          <div className="description-element">
            <Row>
              <FontAwesomeIcon icon={faWarning} className="description-icon" />
              <div class="description-paragraph" data-id="33:4107">
                Wymagane jest pozostawienie okna dialogowego, aby pomyślnie
                wykonać podpis
              </div>
            </Row>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="col-sm-12" id="MessageContainer">
            <div class="alert alert-success">
              Uruchamianie komponentu do podpisu elektronicznego.
            </div>
          </div>

          <div class="col-sm-12">
            <div id="MessageContainer"></div>
            <div class="progress">
              <div
                id="MessageContainerProgress"
                class="progress-bar progress-bar-animated progress-bar-striped active"
                role="progressbar"
                aria-valuenow="5"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <span class="sr-only"></span>
              </div>
            </div>
            {useApplet && (
              <div class="col-sm-12 text-center">
                <div id="appletbox">
                  <applet
                    name="CA"
                    code="pl.com.kir.crypto.applet.CryptoApplet"
                    archive="/Szafir/applet/cryptoapplet.jar"
                    width="1"
                    height="1"
                    alt="Szafir JAVA applet do podpisu elektronicznego."
                  >
                    <param name="Server-Library" value="/Szafir/ext/" />
                    <div class="alert alert-danger">
                      <strong>Strona wymaga Javy.</strong>
                      <br />
                      Pobierz JRE z{" "}
                      <a
                        class="text-danger"
                        href="http://java.com"
                        target="_blank"
                      >
                        <strong>http://java.com</strong>
                      </a>
                      .
                    </div>
                  </applet>
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <form id="GeneralSzafirForm">
            <input
              id="ToDoTaskList"
              name="ToDoTaskList"
              type="hidden"
              value={taskList}
            />
          </form>
        </div>
      </body>
    </>
  );
};

export default SzafirComponent;
